export default __webpack_public_path__ + "static/media/expl-gradcam_03_DE.b1de676c.png";